<template>
    <div class="footer" >
        <div class="mainCenter" id="contactRoom">
            <div style="height: 170px;">
                <div class="footerLeft">
                    <i class="iconfont icon-EI-logo-copy nav-icon" style="font-size: 32px"></i>

                    <p class="footlink">
                        <span v-for="(item,index) in footList" :key="index"><span v-if="index > 0"> · </span>
                            <a v-if="item.url" :href="item.url"  target="_blank">{{item.itemName}}</a>
                            <a v-else="item.url" v-on:click.prevent="aboutUs(menuScrollId[index])" style="cursor:pointer">{{item.itemName}}</a>
                        </span>

                    </p>
                    <p>
                        <i class="iconfont icon-youjian-"></i>
                        <span> zc@zemcho.com</span>
                    </p>
                    <p>
                        <i class="iconfont icon-dianhua"></i>
                        <span> 0769-26620665</span>
                    </p>

                    <p class="address">{{this.siteInfo.copyright}}.   <span v-html="this.siteInfo.icp"></span></p>

                    <!--<div class="flbottom">-->
                    <!--<p class="address">友情链接</p>-->
                    <!--<p>-->
                    <!--<span v-for="item in menuFootData" :key="item.itemId"><a :href="item.url" target="_blank">{{item.itemName}}</a></span>-->
                    <!--&lt;!&ndash;<span>知乎</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span>36氪</span>&ndash;&gt;-->
                    <!--&lt;!&ndash;<span>网易</span>&ndash;&gt;-->
                    <!--</p>-->
                    <!--</div>-->
                </div>

                <div class="footerRight ">
                    <div class="imgBox "  style="margin-right: 24px;">
                        <img src="../../public/static/images/ei.png" alt="">
                        <p>EI公众号</p>
                    </div>

                    <div class="imgBox">
                        <img src="../../public/static/images/gs.png" alt="">
                        <p>微信公众号</p>
                    </div>

                </div>
            </div>


            <div class="flbottom" >
                <p class="address">友情链接</p>
                <p>
                    <span v-for="item in menuFootData" :key="item.itemId"><a :href="item.url" target="_blank">{{item.itemName}}</a></span>
                    <!--<span>知乎</span>-->
                    <!--<span>36氪</span>-->
                    <!--<span>网易</span>-->
                </p>
            </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "Footer",
        data(){
            return{
                menuFootData:[],
                footList:[],
                menuScrollId:['#aboutRoom','#introduceRoom','#advantageRoom','#updateRoom','#contactRoom','#help'],

            }
        },
        created(){
            //友情链接
            this.$GetMenuFootData( { locationId: 2,}).then(() => {
                const { items=[] } = this.$store.state.menuFootData
                this.menuFootData = items
            })

            this.$GetMenuFootData( { locationId: 3,}).then(() => {
                const { items=[] } = this.$store.state.menuFootData
                 this.footList = items
                // console.log(items);
            })
            // 获取站点信息
            this.$GetSiteInfo({ type: 2 }).then(() => {
                this.siteInfo = this.$store.state.siteInfoData;
            })
        },
        methods:{
            aboutUs(type){
                $("html,body").animate({
                    scrollTop:($(type).offset().top - 60)+'px'
                },{
                    duration:500,
                    easing:"swing"
                });
                return false

            }
        }
    }
</script>

<style scoped>

</style>